import { env } from "."

export const list = [
    {
        id: 1,
        title: 'Правила игры',
        text: '',
        content:
            <div className="content">
                <p><b>LUNAR ПОКЕР</b><br /><br />
                    Цель игры – в наборе покерной комбинации карт более сильной, чем у дилера.</p>
                <p>Для игры используется одна стандартная колода из 52-х карт.</p>
                <p>Игрок делает ставку Анте (Ante)и равную ей ставку экспресс бонус в пределах минимума и максимума стола и получает 5 карт. У дилера тоже 5 карт, одна из них открыта.</p>
                <p>Если игрок, посмотрев свои карты, отказывается от игры,его ставка проигрывает.</p>
                <p>За сумму, равную ставке Анте, игрок может обменять от одной до пяти карт или докупить шестую карту. После этого игрок принимает решение – продолжать игру или нет.</p>
                <p>Если игрок принял решение играть, то он должен поставить ставку, равную двум Анте. Если игрок принимает решение не играть (Пас) – теряет при этом ставку Анте. После того, как игроки приняли решение, дилер открывает свои карты</p>
                <p>Если у дилера есть игра, он сравнивает ее с покерными комбинациями игроков.</p>
                <p>Если у дилера нет игры – оплачивается только ставка Анте 1:1.</p>
                <p>У дилера есть игра, если в его картах есть комбинация Туз – Король или выше.</p>
                <p>Если у игрока комбинация старше, чем у дилера, оплачивается только ставка Бет в соответствии с таблицей выплат. Кроме выигрышной комбинации в картах игрока может быть образована вторая комбинация, которая также оплачивается. Вторая комбинация должна включать в себя хотя бы одну карту, не входящую в основную комбинацию. При комбинации «Стрит и пара» оплачивается Стрит и Пара, а не два Стрита.Стрит из шести карт оплачивается как два стрита.Туз-Король и пара не является двумя парами. Если основная комбинация игрока ниже, чем у дилера, то его ставки Анте и Бет проигрывают.</p>
                <p>Если игрок имеет комбинацию Стрит и выше, то он может застраховать свою комбинацию от ситуации «нет игры» у дилера. Для этого он должен поставить ставку в размере от Анте до ожидаемой выплаты по Бет. Ставка Страхование выигрывает в случае, если у дилера нет игры. В противном случае ставка Страхование проигрывает. Ставка Страхование оплачивается 1:1.</p>
                <p>Если игрок имеет комбинацию Стрит и выше, а у дилера нет игры, игрок может за сумму, равную ставке Анте, попытаться купить игру дилеру. При этом дилер меняет старшую карту. Если после обмена карты игровой комбинации у дилера не возникает, оплата ставки Анте не производится.</p>

                <table className="rule-table" border="1" cellPadding="6" cellSpacing="0">
                    <thead>
                        <tr>
                            <th>Комбинация</th>
                            <th>Выплата</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Туз + Король и любая пара</td>
                            <td>1:1</td>
                        </tr>
                        <tr>
                            <td>Две пары</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>Три карты одинакового достоинства</td>
                            <td>3:1</td>
                        </tr>
                        <tr>
                            <td>Стрит</td>
                            <td>4:1</td>
                        </tr>
                        <tr>
                            <td>Флэш</td>
                            <td>5:1</td>
                        </tr>
                        <tr>
                            <td>Фулл-хаус</td>
                            <td>7:1</td>
                        </tr>
                        <tr>
                            <td>Каре</td>
                            <td>20:1</td>
                        </tr>
                        <tr>
                            <td>Стрит-флэш</td>
                            <td>50:1</td>
                        </tr>
                        <tr>
                            <td>Рояль-флэш</td>
                            <td>100:1</td>
                        </tr>
                    </tbody>
                </table>

                <br />
                <p><strong>EXPRESS BONUS</strong> – отдельная ставка на первые пять карт игрока. Выплачивается первой и независимо от руки дилера, строго по таблице выплат.</p>

                <p><strong>Выплата по EXPRESS BONUS</strong></p>
                <p><strong>EXPRESS BONUS</strong> – отдельная ставка на первые пять карт игрока. Выплачивается первой и независимо от руки дилера.</p>

                <table className="rule-table" border="1" cellPadding="6" cellSpacing="0">
                    <thead>
                        <tr>
                            <th>Комбинация</th>
                            <th>Выплата</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Пять карт одного цвета</td>
                            <td>2:1</td>
                        </tr>
                        <tr>
                            <td>Туз – Король – Дама</td>
                            <td>5:1</td>
                        </tr>
                        <tr>
                            <td>Три карты одинакового достоинства</td>
                            <td>8:1</td>
                        </tr>
                        <tr>
                            <td>Стрит</td>
                            <td>30:1</td>
                        </tr>
                        <tr>
                            <td>Флэш</td>
                            <td>60:1</td>
                        </tr>
                        <tr>
                            <td>Фулл-хаус</td>
                            <td>100:1</td>
                        </tr>
                        <tr>
                            <td>Пять картинок (Король, Дама, Валет)</td>
                            <td>120:1</td>
                        </tr>
                        <tr>
                            <td>Каре</td>
                            <td>200:1</td>
                        </tr>
                        <tr>
                            <td>Стрит-флэш</td>
                            <td>250:1</td>
                        </tr>
                        <tr>
                            <td>Рояль-флэш</td>
                            <td>500:1</td>
                        </tr>
                    </tbody>
                </table>

                <br />
                <p>
                    Туз - Король<br />
                    Одна пара – две карты одного достоинства<br />
                    Две пары – две разных пары карт одного достоинства<br />
                    Тройка – три карты одного достоинства<br />
                    Стрит – пять карт подряд не одной масти<br />
                    Флеш – пять карт одной масти<br />
                    Фулл Хаус – три карты одного достоинства плюс пара<br />
                    Каре – четыре карты одного достоинства<br />
                    Стрит Флеш – пять карт подряд одной масти<br />
                    Рояль Флеш – пять старших карт одной масти от десятки до туза<br />
                </p>

                <p>В случае совпадения комбинаций победитель определяется по старшей карте в покерной комбинации, а далее по следующим старшим картам. В комбинации «стрит» 5-4-3-2-А туз являтся младшей картой.</p>

                <p>При полном совпадении всех карт в комбинации объявляется «Stand off» (ничья).</p>
            </div>
    },
    {
        id: 2,
        title: 'Максимальная выплата',
        text: "",
        content:
            <div className="content">
                <p>Максимальная выплата - выигрыш, который может быть выплачен на 1 бокс и не включает ставку ANTE, EXPRESS BONUS, BET и ставку на страхование.</p>
                <p>При этом лимит действует раздельно для двух групп ставок:</p>
                <p>- EXPRESS BONUS — имеет свой собственный предел максимальной выплаты.</p>
                <p>- ANTE, BET и СТРАХОВАНИЕ— имеют общий отдельный предел, который считается суммарно для этих ставок.</p>
            </div>
    },
    {
        id: 3,
        title: 'Выигрышные руки',
        content:
            <div className="content">
                - Отдельные карты перечислены по убыванию: туз (старший или младший), король, дама, валет, 10, 9, 8, 7, 6, 5, 4, 3 и 2.
                Туз может быть самой старшей картой в стрите из туза, короля, дамы, валета и 10 или самой младшей в стрите из 5, 4, 3, 2 и туза.
                Возможные руки в порядке убывания:
                <br /><br />
                Флеш-рояль - это стрит-флеш из туза, короля, дамы, валета и 10 одной масти. В случае НИЧЬЕЙ игроку возвращается его исходная ставка, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/royalFlash.svg`} alt="chips" />
                <br /><br />
                Стрит-флеш - это рука, в состав которой входит пять последовательных карт одной масти; например: девятка, восьмерка, семерка, шестерка и пятерка, все червовой масти. Два стрит-флеша сравниваются по самой старшей карте в каждом из них. В случае НИЧЬЕЙ игроку возвращается его исходная ставка, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/streetFlash.svg`} alt="chips" />
                <br /><br />
                Каре - это рука, в состав которой входит четыре карты одного ранга и любая другая
                карта. Например, четыре туза в руке - это и есть каре. Четверки из карт более высокого
                ранга старше четверок из карт более низкого ранга.                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/fourofakind.svg`} alt="chips" />
                <br /><br />
                Фулл-хаус - это рука, в состав которой входят три карты
                одинакового ранга и пара из карт другого ранга, например: три
                короля и две шестерки. Из двух рук с фулл-хаусом старшей является та, в состав
                которой входят три карты более высокого ранга.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/fullhouse.svg`} alt="chips" />
                <br /><br />
                Флеш - это рука, в состав которой входят любые пять карт одной масти в любой
                последовательности, например: пять карт трефовой масти. Два флеша сравниваются
                как руки со старшей картой; для определения победителя сравнивается самая старшая
                карта в каждой из рук. Если в обеих руках совпадают карты самого высокого ранга,
                сравнивается вторая самая высокая по рангу карта. И так до тех пор, пока не будет
                определен победитель. В случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра
                заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/flash.svg`} alt="chips" />
                <br /><br />
                Стрит - это рука, в состав которой входят пять последовательных карт как минимум
                двух разных мстей, например: девятка, восьмерка, семерка, шестерка и пятерка двух
                или более мастей. Два стрита сравниваются по самой старшей карте в каждой из рук.
                Два стрита с одинаковыми старшими картами имеют одинаковую ценность,
                поскольку масти в сравнении не участвуют. В случае НИЧЬЕЙ игроку возвращается
                ставка Анте и Бет, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/street.svg`} alt="chips" />
                <br /><br />
                Тройка - это рука, в состав которой входят три карты одного ранга и две неодинаковые
                карты другого ранга. Например, у игрока с тремя королями в руке есть тройка.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/threeofakind.svg`} alt="chips" />
                <br /><br />
                Две пары - это рука, в состав которой входят две карты одного ранга, две карты
                другого ранга (которые соответствуют друг другу, но не первой паре) и любая другая
                отличная от их рангов карта.<br />
                Примером является рука, в состав которой входят два туза и два короля. Для оценки
                двух рук с двумя парами сначала сравнивается самая высокая пара каждой из рук.
                Побеждает рука с самой высокой парой. Если в обеих руках имеется одинаковая по
                величине самая высокая пара, сравнивается вторая пара каждой из рук. Если в обеих
                руках имеются две равные пары, победитель определяется по следующей карте. В
                случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра заканчивается.
                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/twopairs.svg`} alt="chips" />
                <br /><br />
                Пара - это рука, в состав которой входят две карты одного ранга (например: два
                короля) и три неодинаковые карты другого ранга.<br />
                Пара - эта самая слабая рука, которая может победить в игре. Пары из карт более
                высокого ранга побеждают пары из карт более низкого ранга. Если в двух руках
                имеется одинаковая пара, сравниваются следующие карты в порядке убывания. В
                случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра заканчивается.                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/pair.svg`} alt="chips" />
                <br /><br />
                Туз Король – минимальная игра. Это рука, в которую входят Туз и Король и три
                неодинаковые карты другого ранга.
                Если в двух руках имеется Туз Король, сравниваются следующие карты в порядке
                убывания. В случае НИЧЬЕЙ игроку возвращается ставка Анте и Бет, а игра
                заканчивается.                <br />
                <img className='rule-combination-img' src={`${env.mediapoint}/images/combinations/aceKing.svg`} alt="chips" />
                {/* <br /><br />
                Старшая карта - это рука, которая состоит из любых пяти карт, не соответствующих ни одному из приведенных выше требований. По существу, не образуется ни одна из рук, и единственное, что имеет значение для игроков в таком случае - это их высшая карта. Если в двух руках имеется одинаковая старшая карта, победитель определяется путем сравения остальных карт в порядке убывания. */}

            </div>
    },
    {
        id: 4,
        title: 'Делайте ставки',
        content:
            <div className="content">

                Панель «ЛИМИТЫ СТАВОК» отображает минимальные и максимальные разрешенные лимиты ставок за столом, которые могут время от времени меняться. Откройте «Лимиты ставок», чтобы проверить свои текущие лимиты.
                <br /><br />
                Lunar Poker 1 -  1 000 $
                <br /><br />
                Для участия в игре вам потребуется достаточное количество средств, необходимое для покрытия ставок. Ваш текущий БАЛАНС отображается на экране.
                <br /><br />
                Ваши средства - БАЛАНС 100 000 $
                <br /><br />
                В иммерсивном виде ТАЙМЕР показывает оставшееся время для размещения ставок. По истечении этого времени ставки больше не принимаются.
                <br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/choiseTimer.png`} alt="bet-ante" />
                <br /><br />
                Индикатор «ОТОБРАЖЕНИЕ ФИШЕК» позволяет выбирать достоинство каждой фишки, которую захотите разместить в виде ставки. Для выбора доступны только те фишки, номинал которых может быть покрыт вашим текущим балансом.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/rules/chips.svg`} alt="chips" />
                <br /><br />
                После выбора фишки сделайте ставку, нажав на соответствующее место для ставки на игровом столе. При каждом нажатии на место для ставок сумма вашей ставки увеличивается на стоимость выбранной фишки или до максимально допустимого лимита для выбранного вами типа ставки. После размещения максимально допустимого лимита ставки дополнительные средства не принимаются, а над вашей ставкой появится сообщение с уведомлением о размещении максимальной ставки.
                <br />
                {/* <img className='rule-button-img' src={`${env.endpoint}/images/ante-express-bet.svg`} alt="bet-ante" /> */}
                <br /><br />
                ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте окно браузера и не открывайте другие вкладки в своем браузере, пока активно время размещения ставок и ставки размещаются на столе. Такие действия могут быть расцедены как выход из игры, и, следовательно, ваши ставки будут отклонены в этом раунде игры.
                <br /><br />
                Кнопка «ПОВТОРИТЬ» позволяет повторить все ставки из предыдущего раунда игры. Эта кнопка остается активной до тех пор, пока не будет размещена первая фишка.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/repeat.svg`} alt="btn" />
                <br /><br />
                Кнопка «УДВОИТЬ» (2×) становится доступной после размещения ставки. С каждым щелчком/нажатием все ваши ставки удваиваются вплоть до максимального предела. Обратите внимание, что вам необходимо иметь достаточное количество средств на счете для удвоения ВСЕХ ваших размещенных ставок.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/double.svg`} alt="btn" />
                <br /><br />
                Кнопка «ОТМЕНА» позволяет удалить последнюю размещенную ставку.
                <br /><br />
                Повторное нажатие кнопки «ОТМЕНА» позволяет отменить ставки по одной в обратном порядке их размещения. Чтобы удалить все свои ставки, удерживайте нажатой кнопку «ОТМЕНА».
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/cancel.svg`} alt="btn" />
                <br /><br />
                Индикатор «ОБЩАЯ СТАВКА» отображает общую сумму ставок, размещенных в текущем раунде.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/totalBet.svg`} alt="total" />
                <br /><br />
                Примите решение
                <br /><br />
                После раздачи ваших карт появится ваша комбинация карт и окно
                <br /><br />
                <img className='rule-img-big widget' src={`${env.mediapoint}/images/rules/game-multi.png`} alt="game" />
                <br /><br />
                После раздачи ваших карт появится ваша комбинация карт и ряд с дополнительным картами, которые будут играть роль карт для обмена и покупку +6 карты.
                Примечение: Карты расчитываются с права на лево и 1-ая карта является +6 картой, в зависимости какое решение вы приняли.
                <br /><br />
                <img className='rule-img-big' src={`${env.mediapoint}/images/rules/additional.svg`} alt="game" />
                <br /><br />
                Для покупки 6-ая карта нажать окно
                <br /><br />
                <img className='rule-img-big' src={`${env.mediapoint}/images/rules/sixth-card.svg`} alt="sixth" />
                <br /><br />
                Для Обмена надо нажать на карты которые вы хотите поменять и нажать на окно ОБМЕНЯТЬ
                <br /><br />
                <img className='rule-img-big' src={`${env.mediapoint}/images/rules/exchange.svg`} alt="exchange" />
                <br /><br />
                Если у вас комбинация Стрит и выше, то появится окно «Страховка»
                <br /><br />
                <img className='rule-img-big' src={`${env.mediapoint}/images/rules/insurance.svg`} alt="insurance" />
                <br /><br />
                При нажатии появится окно «Страховка», так же вам будем предлгаться застроховать комбинацию на 25%, 50%, 75% и 100%.
                <br /><br />
                <img className='rule-img-big box' src={`${env.mediapoint}/images/rules/insurance-sum.svg`} alt="insurance-sum" />
                <br /><br />
                Вы должны решить, что нажать: «BET» для продолжения раунда игры или «ПАС» для завершения раунда игры с потерей размещенных ставок.
                <br /><br />
                <img className='rule-img-big' src={`${env.mediapoint}/images/rules/bet-pass.svg`} alt="btn" />
                <br /><br />
                При нажатии на кнопку «BET» вы продолжаете играть и делаете ставку «BET», Ставка «BET» будет автоматически размещена в месте для ставки «BET».
                <br /><br />
                После щелчка/нажатия кнопки «ПАС» вы потеряете свою ставку АНТЕ.
                Вы сможете наблюдать за ходом игры, но не сможете в ней участвовать. Чтобы сделать новые ставки, вам придется дождаться следующего раунда.
                <br /><br />
                <p>Если игрок имеет комбинацию Стрит и выше, а у дилера нет игры, игрок может за сумму, равную ставке Анте, попытаться купить игру дилеру. </p>
                <img className='rule-img-big' src={`${env.mediapoint}/images/rules/game-purchase.svg`} alt="purchase" />
            </div>
    },
    {
        id: 5,
        title: 'Чат',
        content:
            <div className="content">
                Вы можете обмениваться сообщениями с ведущим игры и другими игроками. Введите свое сообщение в окне ЧАТА. Для отправки сообщения нажмите Ввод или стрелочку, расположенную в поле.
                <br /><br />
                Для игроков, которые некорректно ведут себя в чате, оскорбляют ведущего и других игроков, используют неуместные и/или оскорбительные выражения, доступ к чату будет закрыт.
                <br /><br />
                Используйте кнопку «ЧАТ» для увеличения или закрытия окна чата.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/chat.svg`} alt="chips" />
            </div>
    },
    {
        id: 6,
        title: 'Номер игры',
        content:
            <div className="content">
                Каждый раунд игры идентифицируется уникальным НОМЕРОМ ИГРЫ.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/game-number.svg`} alt="number" />
                <br /><br />
                Пожалуйста, используйте этот номер (или сделайте снимок экрана с номером игры), если вы хотите обратиться в Службу поддержки с вопросами относительно определенного раунда.
            </div>
    },
    {
        id: 7,
        title: 'Звук',
        content:
            <div className="content">
                Кнопка «ЗВУК» включает/выключает все звуки игры и голоса.
                Примите к сведению, что в случае смены стола все звуки включатся автоматически.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/audio-on.svg`} alt="chips" />
                <br /><br />
                Вы можете изменить настройки звука, нажав кнопку «НАСТРОЙКИ» и выбрав вкладку ЗВУК,
            </div>
    },
    {
        id: 8,
        title: 'История игр',
        content:
            <div className="content">
                С помощью кнопки «ИСТОРИЯ» можно открыть окно, в котором будут отображены все сыгранные вами раунды игры и их результаты.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/history.svg`} alt="chips" />
                <br /><br />
                Вы можете просматривать свою игровую активность с помощью . следующего:
                <br /><br />
                • ИСТОРИЯ УЧЕТНОЙ ЗАПИСИ - отображает всю историю вашей учетной записи в виде списка дат, игр, сумм ставок и выплат.
                <br /><br />
                Последний завершенный раунд отображается в самом верху списка.
                <br /><br />
                • ИСТОРИЯ ИГР -- после щелчка/нажатия на определенную игру в столбце ИГРА отображает вашу историю, связанную с определенной игрой.
            </div>
    },
    {
        id: 9,
        title: 'Действия в случае сбоя',
        content:
            <div className="content">
                При сбоях в игре, игровой системе или процедуре игры раунд временно
                приостанавливается, а ведущий игры уведомляет об этом сервис-менеджера. Вы и
                другие игроки увидят сообщение в чате или всплывающее сообщение на экране о том,
                что данный вопрос рассматривается. Если менеджер сможет незамедлительно
                устранить ошибку, раунд игры продолжится, как обычно. В случае отсутствия
                возможности незамедлительного устранения раунд игры аннулируется, а изначальные
                ставки подлежат возмещению всем игрокам, принявшим в нем участие.            </div>
    },
    {
        id: 10,
        title: 'Политика отключения',
        content:
            <div className="content">
                В случае отключения от игры до истечения времени для размещения ставок любые
                сделанные ставки признаются недействительными и возвращаются вам. В случае
                отключения после истечения времени для размещения ставок, сделанные ставки
                признаются действительными и разыгрываются без вашего участия. Результаты
                розыгрыша ставки можно посмотреть в окне «История» после повторного
                подключения.
            </div>
    }
]